import React, { useEffect, useState } from "react";
import { Timeline as AntTimeline } from "antd";
import { TimelineContainer, TimelineCard, TimelineIconCircle } from "./styles";
import IdeaProvider from "../../../../../../shared/provider/IdeaProvider";
import { EventDto } from "../../../../../../shared/dto/NotificationDto";
import moment from "moment";
import 'moment/locale/pt-br'; // Import Portuguese locale for moment
import { FaCheck, FaExchangeAlt, FaLightbulb } from "react-icons/fa";

const ideaProvider = new IdeaProvider();

const eventIcons: { [key: string]: JSX.Element } = {
  CRIOU_IDEIA: (
    <TimelineIconCircle color={"#0057b2"}>
      <FaLightbulb color="white" />
    </TimelineIconCircle>
  ),
  MUDANCA_FASE_IDEIA: (
    <TimelineIconCircle color={"#efac4f"}>
      <FaExchangeAlt color="white" />
    </TimelineIconCircle>
  ),
  AVALIOU_IDEIA: (
    <TimelineIconCircle color={"#40913f"}>
      <FaCheck color="white" />
    </TimelineIconCircle>
  ),
};

function Timeline({ ideaId }: { ideaId: string }): JSX.Element {
  const [events, setEvents] = useState<EventDto[]>([]);

  useEffect(() => {
    async function fetchEvents() {
      try {
        const events = await ideaProvider.getEventsWithTimelineTrueByIdeaId(ideaId);
        events.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
        setEvents(events);
      } catch (error) {
        console.error("Erro ao buscar eventos:", error);
      }
    }

    fetchEvents();
  }, [ideaId]);

  return (
    <TimelineContainer>
      <AntTimeline mode="left">
        {events.map((event) => (
            <AntTimeline.Item key={event.eventId} dot={eventIcons[event.eventType]}>
            <TimelineCard>
              <div className="date">{moment(event.createdAt).locale("pt-br").format("DD [de] MMMM [de] YYYY")}</div>
              <div className="title">{event.title}</div>
            </TimelineCard>
            </AntTimeline.Item>
        ))}
      </AntTimeline>
    </TimelineContainer>
  );
}

export default Timeline;